import { Controller } from "@hotwired/stimulus";
import { Drawer } from "flowbite";

// Connects to data-controller="navbar-menu"
export default class extends Controller {
  static targets = ["drawer", "hamburger"];

  connect() {
    // Initialize Flowbite drawer
    const options = {
      placement: 'right',
      backdrop: true,
      bodyScrolling: false,
      edge: false,
      edgeOffset: '',
      backdropClasses: 'bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40'
    };

    this.drawer = new Drawer(this.drawerTarget, options);
  }

  toggleMenu() {
    if (this.drawer.isVisible()) {
      this.drawer.hide();
      sessionStorage.setItem('submenuOpen', 'false');
    } else {
      this.drawer.show();
      sessionStorage.setItem('submenuOpen', 'true');
    }
  }

  closeMenu() {
    this.drawer.hide();
    sessionStorage.setItem('submenuOpen', 'false');
  }
}